// Risk levels emitted by FMECA criticality calculation — values are also
// persisted to the backend, so they must remain stable.
export const RISK_LEVEL = Object.freeze({
  HIGH: 'High',
  MEDIUM_HIGH: 'Medium-High',
  MEDIUM: 'Medium',
  LOW: 'Low',
});

export const RISK_LEVEL_COLORS = Object.freeze({
  [RISK_LEVEL.HIGH]: 'error',
  [RISK_LEVEL.MEDIUM_HIGH]: 'warning',
  [RISK_LEVEL.MEDIUM]: 'info',
  [RISK_LEVEL.LOW]: 'success',
});
